import React, { useState } from 'react';
import i18next from 'i18next';
import { DownloadAppDialog } from 'apps/repository/views/downloadAppDialog';

export const DownloadAppBtn = () => {
  const [showDownloadAppDialog, setOpen] = useState(false);

  return (
    <>
      <div
        onClick={() => {
          setOpen(true);
        }}
        className=' rounded-full border border-white p-1 px-2 select-none text-white text-xs cursor-pointer mr-2'
      >
        {i18next.t('Download Desktop App')}
      </div>
      <DownloadAppDialog
        visible={showDownloadAppDialog}
        onClose={() => {
          setOpen(false);
        }}
      />
    </>
  );
};
